import { init } from '@fullstory/browser';
import * as Sentry from '@sentry/react';
import { Amplify } from 'aws-amplify';
import { fetchAuthSession } from 'aws-amplify/auth';
import ReactDOM from 'react-dom/client';
import App from './App';
import config from './config';

Sentry.init({
  dsn: 'https://f29062b5b1a886c376e29159457c2f34@o4509606702415873.ingest.us.sentry.io/4509611299504128',
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  environment: config.web.ENVIRONMENT,
});

init({ orgId: 'o-23GEG8-na1' });

Amplify.configure(
  {
    Auth: {
      Cognito: {
        //   mandatorySignIn: true,
        //   region: config.cognito.REGION,
        //   userPoolWebClientId: config.cognito.APP_CLIENT_ID,
        allowGuestAccess: true,
        userPoolId: config.cognito.USER_POOL_ID,
        identityPoolId: config.cognito.IDENTITY_POOL_ID,
        userPoolClientId: config.cognito.APP_CLIENT_ID,
      },
    },
    Storage: {
      S3: {
        region: config.s3.REGION,
        bucket: config.s3.BUCKET,
        //   identityPoolId: config.cognito.IDENTITY_POOL_ID,
      },
    },
    API: {
      REST: {
        Api: {
          endpoint: `${config.apiGateway.URL}`,
          region: config.apiGateway.REGION,
        },
        MailersApi: {
          endpoint: `${config.mailersApiGateway.URL}`,
          region: config.mailersApiGateway.REGION,
        },
      },
    },
  },
  {
    API: {
      REST: {
        headers: async ({ apiName }: { apiName: string }) => {
          if (apiName !== 'MailersApi') {
            return {} as Record<string, string>;
          }

          const tokens = (await fetchAuthSession()).tokens;
          const jwt = tokens?.idToken?.toString() || tokens?.accessToken?.toString();
          const headers: Record<string, string> = {};
          if (jwt) {
            headers.Authorization = `Bearer ${jwt}`;
          }

          return headers;
        },
      },
    },
  }
);

// You can get the current config object
// const currentConfig = Amplify.getConfig();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <App retrieveUrl={config.web.RETRIEVE_URL} />
);
